// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_infoDialog-styles-module--dialog--2tKij","close":"_infoDialog-styles-module--close--2nJD0","body":"_infoDialog-styles-module--body--LpaHJ"};